import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * A tooltip that still shows over a disabled button.
 *
 * A disabled button fires no pointer events, so MUI's Tooltip cannot open on it directly; the span
 * takes the hover instead. An empty title shows nothing, so callers pass '' when there is nothing
 * to explain.
 */
const DisabledButtonTooltip = ({ title, children }) => (
  <Tooltip title={title} arrow placement='top'>
    <span style={{ display: 'inline-flex' }}>{children}</span>
  </Tooltip>
);

DisabledButtonTooltip.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

DisabledButtonTooltip.defaultProps = {
  title: '',
};

export default DisabledButtonTooltip;
